import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper = new Swiper(".mySwiper", {
    spaceBetween: '4%',
    slidesPerView: 4,
    direction: 'vertical',

});
var swiper2 = new Swiper(".mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
    navigation: {
        nextEl: ".section1  .swiper-button-next",
        prevEl: ".section1  .swiper-button-prev",
    },
});